import React, { useEffect, useState } from "react";

export const Header = (props) => {
 
  return (
    
    <header id="header">
      <div className="intro">
        <div >
          <div className="contenedor">
            <div className="row">
              <div className="col-md-8 col-md-offset-0 intro-text">
                <div className="animacion">
                  <h1 className="titulo">
                  {
                    props.data && props.data.titlesOne ? (
                    props.data.titlesOne.split('').map((letra, index) => (
                    <span key={index} style={{ animationDelay: `${index * 0.2}s` }}>
                    {letra}
                    </span>
                    ))
                    ) : (
                      <span>Loading...</span>
                    )
                    }
                  </h1>
                  <h1 className="tituloMobile">
                  {
                    props.data && props.data.titlesMobileOne ? (
                    props.data.titlesMobileOne.split('').map((letra, index) => (
                    <span key={index} style={{ animationDelay: `${index * 0.2}s` }}>
                    {letra}
                    </span>
                    ))
                    ) : (
                      <span>Loading...</span>
                    )
                    }
                  </h1><br></br>
                  <h1 className="tituloMobile">
                  {
                    props.data && props.data.titlesMobileTwo ? (
                    props.data.titlesMobileTwo.split('').map((letra, index) => (
                    <span key={index} style={{ animationDelay: `${index * 0.2}s` }}>
                    {letra}
                    </span>
                    ))
                    ) : (
                      <span>Loading...</span>
                    )
                    }
                  </h1>
                </div>
                  <div className="qodef-h2">
                    <h2>{props.data ? props.data.titlesTwo : "Loading"}<br></br>
                    {props.data ? props.data.titlesThree : "Loading"}</h2>
                  </div>

                  <p>{props.data ? props.data.paragraph : "Loading"}</p>

                    <div className="elementor-widget-container">
                      <a className="qodef-shortcode qodef-m  qodef-button qodef-layout--filled qodef-size--small qodef-html--link " href="#Servicios" target="_self" style={{color: '#FFFFFF', backgroundColor: 'rgba(227,39,38)'}}>
                        <span className="qodef-m-text">Conocer Más</span>
                      </a>
					         </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
  );
};